import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { ROLE } from '@/shared/data/permissionSystem'

export const useCurrentUser = () => {
  const page = usePage()

  const currentUser = computed(() => page.props.shared.currentUser)

  const timezone = computed(() => {
    const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const tz =
      currentUser.value.accessControl.role !== ROLE.GUEST
        ? currentUser.value.timezone || defaultTimezone
        : defaultTimezone
    if (!tz) return 'Invalid timezone'
    return tz
  })

  return {
    currentUser,
    timezone,
  }
}
